import {Route, RouteProps} from 'react-router-dom';
import {Permission} from '../../backend/interfaces/permission';
import {useAuth} from '../../contexts/auth/context';
import MissingPermissionsScreen from '../missing-permissions-screen';

interface PermissionsRequiredRouteProps extends RouteProps {
  requiredPermissions: Permission[];
}

const PermissionsRequiredRoute = ({
  requiredPermissions,
  ...rest
}: PermissionsRequiredRouteProps) => {
  const {hasReadPermission, hasWritePermission} = useAuth();

  let hasRequiredPermissions;

  // By default, if no permissions are given, render the component.
  if (!requiredPermissions) {
    hasRequiredPermissions = true;
  } else {
    hasRequiredPermissions = requiredPermissions.every((permission) => {
      if (permission.canWrite) {
        return hasWritePermission(permission.type);
      } else if (permission.canRead) {
        return hasReadPermission(permission.type);
      }

      // if both canRead and canWrite are passed as false, the user should be able to access the page regardless
      // of the actual permissions he has.
      return true;
    });
  }

  return hasRequiredPermissions ? <Route {...rest} /> : <MissingPermissionsScreen />;
};

export default PermissionsRequiredRoute;
